<template>
  <div class="v-d-statistics">
    <img class="deco-img top-pink-arc-deco" src="@/assets/img/index/bg_kv_pink.svg" />
    <!-- <img class="deco-img pink-arc-deco" src="@/assets/img/index/bg_kv_2_pink.svg" /> -->
    <img class="deco-img bottom-deco" src="@/assets/img/index/bg_pink.svg" />

    <div class="mobile-show">
      <carousel :carouselList="statisticsList" :showImg="false" />
    </div>

    <div class="tablet-show">
      <div class="v-d-statistics__content g-content">
        <ul class="statistics-list" :style="{ transform: `translateX(-${(currIndex * 100) / statisticsList.length}%)` }">
          <li class="statistics-list__item" v-for="item of statisticsList" :key="item.id">
            <div class="statistics-list__item__box">
              <statistics-box :data="item.data" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, shallowRef } from 'vue';
import { v4 as uuid } from 'uuid';
import StatisticsBox from '@/components/Home/StatisticsBox.vue';
import statisticsIcon1 from '@/assets/img/index/pic_1.svg';
import statisticsIcon2 from '@/assets/img/index/pic_2.svg';
import statisticsIcon3 from '@/assets/img/index/pic_3.svg';
import statisticsIcon4 from '@/assets/img/index/pic_4.svg';
import statisticsIcon5 from '@/assets/img/index/pic_5.svg';
import statisticsIcon6 from '@/assets/img/index/pic_6.svg';
import Carousel from '@/components/Global/Carousel.vue';

export default defineComponent({
  name: 'Statistics',
  components: {
    StatisticsBox,
    Carousel,
  },
  setup() {
    const currIndex = ref(0);
    const dotList = [0, 1, 2];
    const handleDotIndex = (idx) => {
      currIndex.value = idx;
    };

    const statisticsList = [
      {
        id: uuid(),
        data: [
          {
            id: uuid(),
            extraType: 'withStr',
            icon: statisticsIcon1,
            // number: '9,000',
            number: 9000,
            animation: false,
            label: '早產兒個案住院醫療補助',
          },
          {
            id: uuid(),
            icon: statisticsIcon2,
            // number: '37,274,169',
            number: 43169272,
            animation: true,
            label: '早產兒出院後醫療器材補助',
          },
        ],
        renderContent: shallowRef(StatisticsBox),
      },
      {
        id: uuid(),
        data: [
          {
            id: uuid(),
            icon: statisticsIcon3,
            number: 4276500,
            animation: true,
            label: '早產兒出院後居家訪視服務補助',
          },
          {
            id: uuid(),
            icon: statisticsIcon4,
            // number: '27,779,369',
            number: 30279369,
            animation: true,
            label: '合約醫院早產兒病房醫療儀器捐助',
          },
        ],
        renderContent: shallowRef(StatisticsBox),
      },
      {
        id: uuid(),
        data: [
          {
            id: uuid(),
            icon: statisticsIcon5,
            // number: '60,775',
            number: 74229,
            animation: true,
            label: '極低出生體重早產兒追蹤檢查',
          },

          {
            id: uuid(),
            icon: statisticsIcon6,
            // number: '40,000',
            number: 120281,
            animation: true,
            label: '基金會30年服務早產兒人次',
          },
        ],
        renderContent: shallowRef(StatisticsBox),
      },
    ];

    return {
      statisticsList,
      dotList,
      currIndex,
      handleDotIndex,
    };
  },
});
</script>

<style lang="scss" scoepd>
@import '~@/styles/share/home.scss';
@import '~@/styles/utils/_rwd.scss';

.v-d-statistics {
  background-color: $c-main-light-pink;
  padding-top: 50px;
  padding-bottom: 60px;
  position: relative;

  &__content {
    overflow: hidden;
    width: 100%;
  }
}

.statistics-list {
  @include flex();
  flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin: 0 -10px;
  width: 300%;
  transition: 0.4s;
  // transform: translateX(-33.333333%);
  // overflow: auto;

  &__item {
    // @include flex(flex-start);
    flex: none;
    width: 33.333333%;

    &__box {
      box-sizing: border-box;
      @include flex(center, center, column);
    }
  }
}

.bottom-deco {
  width: 100%;
  @include position(tl, 100%, 0);
}

.dots {
  @include flex(center);
  margin-top: 30px;
  cursor: pointer;

  &__circle {
    @include circle(10px);
    background-color: rgba($c-grey2, 0.5);

    &+& {
      margin-left: 10px;
    }

    &--active {
      background-color: $c-main-yellow;
    }
  }
}

.tablet-show {
  display: none;
}

@media screen and (min-width: $portrait) {
  .v-d-statistics {}

  .statistics-list {
    flex-wrap: nowrap;
    margin: 0px;
    width: 100%;
    transition: 0.4s;
    // transform: translateX(-33.333333%);

    // overflow: auto;

    &__item {
      flex: 1;
      width: auto;

      &+& {
        // margin-left: 87px;
      }

      // width: 100%;

      &__box {
        box-sizing: border-box;
        @include flex(center, center, column);
      }
    }
  }

  .top-pink-arc-deco {
    width: 100%;
    @include position(bl, 100%, 0);
  }

  .pink-arc-deco {
    @include position(tl, 100%, 0);
  }
}

@media screen and (min-width: $tablet) {
  .mobile-show {
    display: none;
  }

  .tablet-show {
    display: block;
  }
}

@media screen and (min-width: $sm-pc) {}

@media screen and (min-width: $pc) {
  @media screen and (min-width: $pc) {
    .v-d-statistics {
      padding-top: 200px;

      // override default
    }
  }
}
</style>
